module.exports = __webpack_public_path__ + "openstack.logo.36f6c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/logo/openstack.logo.svg
// module id = 3714
// module chunks = 0